module.exports = __webpack_public_path__ + "static/media/PuntoDinamicoInstancia.js.69b88f0f.sample";